import React from 'react'

export type TemplateEditorUnsavedDialogButton = {
  label: string
  onClick?: () => void
  className?: string | null
}

export type TemplateEditorUnsavedCustomUiArgs = {
  title?: string
  message: string
  buttons: TemplateEditorUnsavedDialogButton[]
  onClose: () => void
}

/**
 * Custom body for `react-confirm-alert` when leaving a template editor item with unsaved edits.
 */
export function TemplateEditorUnsavedChangesDialog(props: {
  title: string
  message: string
  buttons: TemplateEditorUnsavedDialogButton[]
  onClose: () => void
}) {
  return (
    <div
      className="template-editor-unsaved-dialog"
      role="alertdialog"
      aria-labelledby="template-editor-unsaved-title"
      aria-describedby="template-editor-unsaved-desc"
      onClick={(e) => e.stopPropagation()}
    >
      <h2
        id="template-editor-unsaved-title"
        className="template-editor-unsaved-dialog__title"
      >
        {props.title}
      </h2>
      <p
        id="template-editor-unsaved-desc"
        className="template-editor-unsaved-dialog__msg"
      >
        {props.message}
      </p>
      <div className="template-editor-unsaved-dialog__actions">
        {props.buttons.map((btn, i) => (
          <button
            key={i}
            type="button"
            className={
              i === 0
                ? 'template-editor-unsaved-dialog__btn template-editor-unsaved-dialog__btn--muted'
                : i === 1
                  ? 'template-editor-unsaved-dialog__btn template-editor-unsaved-dialog__btn--danger'
                  : 'template-editor-unsaved-dialog__btn template-editor-unsaved-dialog__btn--primary'
            }
            onClick={() => {
              btn.onClick?.()
              props.onClose()
            }}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  )
}
